import { render } from "../workflow_dashboard/workflow_dashboard.html?vue&type=template&id=790350da&external"
import script from "../workflow_dashboard/workflow_dashboard.js?vue&type=script&lang=js&external"
export * from "../workflow_dashboard/workflow_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__